import type { Resource } from '../../';
export const search_box_frame_didYouMean: Resource = {"default":"Did you mean?"};
